module.exports = __webpack_public_path__ + "img/f4541eacb0b1495480f77794060bf780.af94bc84.jpg";